import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { BootstrapperBase, ExportToken } from '@trustedshops/tswp-core-common';
import {
  HasFeatureParams,
  ProductFeatureConfig,
  ProductFeatureData,
  ProductFeatureService,
  TOKENS as MASTERDATA_TOKENS,
} from '@trustedshops/tswp-core-masterdata';
import { ENVIRONMENT, Environment } from '../models/environment.type';

/**
 * Overwrite the default implementation of the ProductFeatureService.
 * Product Feature API is not available for employees.
 * getFeatures returns null; initialize is a no-op.
 */
@Injectable()
@ExportToken(MASTERDATA_TOKENS.ProductFeatureService)
export class ProductFeatureServiceEmployee implements ProductFeatureService {
  private static readonly TYPE = 'ProductFeatureService';

  initialize(_config: ProductFeatureConfig): Promise<void> {
    return Promise.resolve(void 0);
  }

  getFeatures(): Promise<ProductFeatureData | null> {
    return Promise.resolve(null);
  }

  hasFeature(_params: HasFeatureParams): Promise<boolean> {
    return Promise.resolve(false);
  }
}

@Injectable()
export class ProductFeatureBootstrapper implements BootstrapperBase {
  public constructor(
    @Inject(ENVIRONMENT) private readonly _environment: Environment,
    @Inject(MASTERDATA_TOKENS.ProductFeatureService)
    private readonly _productFeatureService: ProductFeatureService
  ) {}

  public async initialize(): Promise<void> {
    // Product Feature API is not available for employees — the stub initialize() is a no-op,
    // so these values are never used to make a request.
    await this._productFeatureService.initialize({
      basePath: '',
      accountId: '',
      companiesBasePath: '',
    });
  }
}

export const ProductFeatureBootstrapperInitializer = [
  {
    provide: MASTERDATA_TOKENS.ProductFeatureService,
    useClass: ProductFeatureServiceEmployee,
  },
  ProductFeatureBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => () =>
      initializer.initialize(),
    deps: [ProductFeatureBootstrapper],
  },
];
